export const softwareData=[
  {
    "name": "Microsoft Azure",
    "impact": 0,
    "exploitability": 10,
    "base": 5,
    "category": "Cloud Service Provider",
    "severity": "Low",
    "size": 2000,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "PCI DSS",
      "HIPAA",
      "NIST"
    ],
    "lastAssessment": "2024-01-15",
    "securityControls": "High",
    "dataExposureRisk": "Low",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Low",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "Palo Alto Networks",
    "impact": 8.5,
    "exploitability": 7.2,
    "base": 7.9,
    "category": "Vendor",
    "severity": "High",
    "size": 5000,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "PCI DSS",
      "NIST"
    ],
    "lastAssessment": "2024-01-20",
    "securityControls": "Critical",
    "dataExposureRisk": "High",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "High",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "CrowdStrike",
    "impact": 8,
    "exploitability": 6.5,
    "base": 7.3,
    "category": "Vendor",
    "severity": "High",
    "size": 4000,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "NIST"
    ],
    "lastAssessment": "2024-01-28",
    "securityControls": "Critical",
    "dataExposureRisk": "Moderate",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Moderate",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "AWS",
    "impact": 0,
    "exploitability": 8,
    "base": 6,
    "category": "Cloud Service Provider",
    "severity": "Low",
    "size": 2200,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "PCI DSS",
      "HIPAA",
      "NIST",
      "FedRAMP"
    ],
    "lastAssessment": "2024-01-30",
    "securityControls": "High",
    "dataExposureRisk": "Moderate",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Low",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "Google Cloud Platform",
    "impact": 0,
    "exploitability": 7.5,
    "base": 5.5,
    "category": "Cloud Service Provider",
    "severity": "Low",
    "size": 2100,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "PCI DSS",
      "NIST"
    ],
    "lastAssessment": "2024-01-18",
    "securityControls": "High",
    "dataExposureRisk": "Low",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Low",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "Salesforce",
    "impact": 7.8,
    "exploitability": 8.5,
    "base": 8.1,
    "category": "CRM",
    "severity": "High",
    "size": 1500,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "GDPR"
    ],
    "lastAssessment": "2024-02-01",
    "securityControls": "Critical",
    "dataExposureRisk": "High",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "High",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "HubSpot",
    "impact": 6.5,
    "exploitability": 7,
    "base": 7.2,
    "category": "CRM",
    "severity": "Medium",
    "size": 1200,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "GDPR"
    ],
    "lastAssessment": "2024-01-20",
    "securityControls": "Medium",
    "dataExposureRisk": "Moderate",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Moderate",
    "redundancy": false,
    "isEnabled": true
  },
  {
    "name": "Zoho CRM",
    "impact": 5.5,
    "exploitability": 6.8,
    "base": 6.2,
    "category": "CRM",
    "severity": "Medium",
    "size": 800,
    "frameworks": [
      "SOC 2",
      "GDPR"
    ],
    "lastAssessment": "2024-02-10",
    "securityControls": "Medium",
    "dataExposureRisk": "Low",
    "encryptionAtRest": true,
    "encryptionInTransit": false,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Low",
    "redundancy": false,
    "isEnabled": true
  },
  {
    "name": "Oracle Cloud",
    "impact": 0,
    "exploitability": 7.8,
    "base": 7,
    "category": "Database Provider",
    "severity": "Low",
    "size": 1800,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "PCI DSS"
    ],
    "lastAssessment": "2024-01-20",
    "securityControls": "High",
    "dataExposureRisk": "Low",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Low",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "ACME Corporation",
    "impact": 8,
    "exploitability": 9,
    "base": 9,
    "category": "Database Provider",
    "severity": "Critical",
    "size": 2000,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "PCI DSS",
      "HIPAA",
      "NIST"
    ],
    "lastAssessment": "2024-01-20",
    "securityControls": "Critical",
    "dataExposureRisk": "High",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "High",
    "redundancy": true,
    "isEnabled": false
  },
  {
    "name": "MongoDB Atlas",
    "impact": 6.2,
    "exploitability": 7,
    "base": 6.5,
    "category": "Database Provider",
    "severity": "High",
    "size": 1400,
    "frameworks": [
      "SOC 2",
      "GDPR"
    ],
    "lastAssessment": "2024-02-05",
    "securityControls": "Medium",
    "dataExposureRisk": "Moderate",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Moderate",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "Amazon RDS",
    "impact": 5.8,
    "exploitability": 6.8,
    "base": 6.3,
    "category": "Database Provider",
    "severity": "Medium",
    "size": 1700,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "NIST"
    ],
    "lastAssessment": "2024-01-25",
    "securityControls": "Medium",
    "dataExposureRisk": "Low",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Low",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "ServiceNow",
    "impact": 5.5,
    "exploitability": 6.5,
    "base": 6,
    "category": "ITSM",
    "severity": "Medium",
    "size": 1200,
    "frameworks": [
      "SOC 2",
      "ISO 27001"
    ],
    "lastAssessment": "2024-02-10",
    "securityControls": "Medium",
    "dataExposureRisk": "Low",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Low",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "Jira Service Management",
    "impact": 6,
    "exploitability": 6.2,
    "base": 6.1,
    "category": "ITSM",
    "severity": "Medium",
    "size": 1000,
    "frameworks": [
      "SOC 2",
      "ISO 27001"
    ],
    "lastAssessment": "2024-01-30",
    "securityControls": "Medium",
    "dataExposureRisk": "Moderate",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Moderate",
    "redundancy": false,
    "isEnabled": true
  },
  {
    "name": "BMC Helix",
    "impact": 5.2,
    "exploitability": 6,
    "base": 5.8,
    "category": "ITSM",
    "severity": "Medium",
    "size": 1300,
    "frameworks": [
      "SOC 2"
    ],
    "lastAssessment": "2024-02-02",
    "securityControls": "Medium",
    "dataExposureRisk": "Low",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Low",
    "redundancy": false,
    "isEnabled": true
  },
  {
    "name": "Workday",
    "impact": 4.8,
    "exploitability": 5.2,
    "base": 5,
    "category": "HR Systems",
    "severity": "Medium",
    "size": 900,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "GDPR"
    ],
    "lastAssessment": "2024-01-25",
    "securityControls": "Medium",
    "dataExposureRisk": "Low",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": false,
    "loggingEnabled": true,
    "dataTypeExposure": "Low",
    "redundancy": false,
    "isEnabled": true
  },
  {
    "name": "SAP SuccessFactors",
    "impact": 6,
    "exploitability": 6.5,
    "base": 6.2,
    "category": "HR Systems",
    "severity": "High",
    "size": 1100,
    "frameworks": [
      "SOC 2",
      "ISO 27001"
    ],
    "lastAssessment": "2024-01-29",
    "securityControls": "Critical",
    "dataExposureRisk": "High",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "High",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "BambooHR",
    "impact": 4.5,
    "exploitability": 5,
    "base": 5,
    "category": "HR Systems",
    "severity": "Medium",
    "size": 700,
    "frameworks": [
      "SOC 2"
    ],
    "lastAssessment": "2024-02-07",
    "securityControls": "Medium",
    "dataExposureRisk": "Low",
    "encryptionAtRest": true,
    "encryptionInTransit": false,
    "mfaEnabled": false,
    "loggingEnabled": false,
    "dataTypeExposure": "Low",
    "redundancy": false,
    "isEnabled": true
  },
  {
    "name": "DocuSign",
    "impact": 6.8,
    "exploitability": 7.2,
    "base": 7,
    "category": "Digital Signature",
    "severity": "High",
    "size": 800,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "GDPR"
    ],
    "lastAssessment": "2024-02-05",
    "securityControls": "Critical",
    "dataExposureRisk": "High",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "High",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "Adobe Sign",
    "impact": 6.5,
    "exploitability": 6.8,
    "base": 6.7,
    "category": "Digital Signature",
    "severity": "High",
    "size": 850,
    "frameworks": [
      "SOC 2",
      "GDPR"
    ],
    "lastAssessment": "2024-02-03",
    "securityControls": "Critical",
    "dataExposureRisk": "High",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "High",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "HelloSign",
    "impact": 5.8,
    "exploitability": 6,
    "base": 5.9,
    "category": "Digital Signature",
    "severity": "Medium",
    "size": 600,
    "frameworks": [
      "SOC 2"
    ],
    "lastAssessment": "2024-02-09",
    "securityControls": "Medium",
    "dataExposureRisk": "Low",
    "encryptionAtRest": true,
    "encryptionInTransit": false,
    "mfaEnabled": false,
    "loggingEnabled": true,
    "dataTypeExposure": "Low",
    "redundancy": false,
    "isEnabled": true
  },
  {
    "name": "Okta",
    "impact": 7.5,
    "exploitability": 7.8,
    "base": 7.6,
    "category": "Identity Management",
    "severity": "High",
    "size": 1000,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "NIST"
    ],
    "lastAssessment": "2024-01-28",
    "securityControls": "Critical",
    "dataExposureRisk": "High",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "High",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "Ping Identity",
    "impact": 7,
    "exploitability": 7.5,
    "base": 7.2,
    "category": "Identity Management",
    "severity": "High",
    "size": 950,
    "frameworks": [
      "SOC 2",
      "ISO 27001"
    ],
    "lastAssessment": "2024-01-25",
    "securityControls": "Critical",
    "dataExposureRisk": "High",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "High",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "Microsoft Entra",
    "impact": 6.8,
    "exploitability": 7,
    "base": 6.9,
    "category": "Identity Management",
    "severity": "Medium",
    "size": 1200,
    "frameworks": [
      "SOC 2",
      "ISO 27001"
    ],
    "lastAssessment": "2024-02-10",
    "securityControls": "Medium",
    "dataExposureRisk": "Moderate",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Moderate",
    "redundancy": false,
    "isEnabled": true
  }
]